module.exports = __webpack_public_path__ + "static/Prop_A_Affordable_Housing.3487cf05.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Prop_A_Affordable_Housing.pdf
// module id = 263
// module chunks = 264074303502183